var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:( _obj = {'collapsemenu':_vm.collapsemenu===true}, _obj[this.lineaClass] = true, _obj ),attrs:{"id":"body-row"}},[_c('Sidebar'),_vm._v(" "),_c('div',{attrs:{"id":"panel-principal"}},[_c('navbar'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('Footer')],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35739389","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content.vue
// module id = null
// module chunks = 